import React, { useState, useRef } from "react";
import { Box, Container, Grid, Typography } from "@mui/material";

export const ThreeColSection: React.FC = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const cards = [
    {
      id: 1,
      title: "Masajes Orientales",
      desc: "Sumérgete en el encanto ancestral de nuestros masajes orientales, donde la sabiduría milenaria se fusiona con el arte del bienestar.",
      icon: (
        <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: "block" }}>
          {/* Central Petal */}
          <path d="M24 6C24 6 20 16 20 25C20 29.5 21.8 33 24 35C26.2 33 28 29.5 28 25C28 16 24 6 24 6Z" fill="url(#goldLotus)" />
          {/* Left Inner Petal */}
          <path d="M24 18C19 16 11 20 11 28C11 33.5 16 36 21 35.5C21.8 32.5 22.8 28.5 24 25C24.5 22.5 24 18 24 18Z" fill="url(#goldLotus)" opacity="0.88" />
          {/* Right Inner Petal */}
          <path d="M24 18C29 16 37 20 37 28C37 33.5 32 36 27 35.5C26.2 32.5 25.2 28.5 24 25C23.5 22.5 24 18 24 18Z" fill="url(#goldLotus)" opacity="0.88" />
          {/* Far Left Petal */}
          <path d="M19 33C14 31 5 32 5 37C5 40 10 41 16 39.5C17.5 37 18.5 35 19 33Z" fill="url(#goldLotus)" opacity="0.75" />
          {/* Far Right Petal */}
          <path d="M29 33C34 31 43 32 43 37C43 40 38 41 32 39.5C30.5 37 29.5 35 29 33Z" fill="url(#goldLotus)" opacity="0.75" />
          {/* Base Line */}
          <path d="M14 42C19 43.5 29 43.5 34 42C30 40.5 18 40.5 14 42Z" fill="url(#goldLotus)" />
        </svg>
      ),
    },
    {
      id: 2,
      title: "Modernas instalaciones",
      desc: "En nuestro oasis de tranquilidad, cada tratamiento está diseñado para proporcionarte un escape rejuvenecedor, restaurando tu equilibrio y serenidad.",
      icon: (
        <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: "block" }}>
          {/* Candle flame */}
          <path d="M24 4C24 4 21 9 21 12C21 13.66 22.34 15 24 15C25.66 15 27 13.66 27 12C27 9 24 4 24 4Z" fill="url(#goldZen)" />
          <circle cx="24" cy="11.5" r="1.5" fill="#FFFFFF" />
          {/* Top Stone */}
          <path d="M24 18C18.5 18 16 20.8 16 22.8C16 24.8 18.5 25.8 24 25.8C29.5 25.8 32 24.8 32 22.8C32 20.8 29.5 18 24 18Z" fill="url(#goldZen)" />
          {/* Middle Stone */}
          <path d="M24 27C16.5 27 13 29.8 13 32.2C13 34.6 16.5 35.6 24 35.6C31.5 35.6 35 34.6 35 32.2C35 29.8 31.5 27 24 27Z" fill="url(#goldZen)" opacity="0.9" />
          {/* Bottom Stone */}
          <path d="M24 37C14 37 9 39.8 9 42.5C9 44.8 14 45.8 24 45.8C34 45.8 39 44.8 39 42.5C39 39.8 34 37 24 37Z" fill="url(#goldZen)" opacity="0.8" />
          {/* Sparkles */}
          <path d="M12 11L13 13.5L15.5 14.5L13 15.5L12 18L11 15.5L8.5 14.5L11 13.5L12 11Z" fill="url(#goldZen)" opacity="0.75" />
          <path d="M36 9L37 11L39 11.5L37 12L36 14L35 12L33 11.5L35 11L36 9Z" fill="url(#goldZen)" opacity="0.75" />
        </svg>
      ),
    },
    {
      id: 3,
      title: "Cerca de ti",
      desc: "Te esperamos en una ubicación privilegiada, ofreciéndote fácil acceso para que disfrutes de una pausa rejuvenecedora en la ciudad.",
      icon: (
        <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: "block" }}>
          {/* Outer ripple */}
          <ellipse cx="24" cy="40" rx="16" ry="4.5" stroke="url(#goldLocation)" strokeWidth="1.5" strokeDasharray="3 3" opacity="0.6" />
          <ellipse cx="24" cy="40" rx="9" ry="2.8" fill="url(#goldLocation)" opacity="0.35" />
          {/* Pin Body */}
          <path d="M24 6C16.82 6 11 11.82 11 19C11 28.5 22.2 38.2 22.7 38.6C23.1 38.9 23.6 39.1 24 39.1C24.4 39.1 24.9 38.9 25.3 38.6C25.8 38.2 37 28.5 37 19C37 11.82 31.18 6 24 6Z" fill="url(#goldLocation)" />
          {/* Inner Star */}
          <circle cx="24" cy="18" r="5.2" fill="#FFFFFF" />
          <path d="M24 14.5L25.1 17L27.6 17.3L25.8 19.1L26.3 21.6L24 20.3L21.7 21.6L22.2 19.1L20.4 17.3L22.9 17L24 14.5Z" fill="#9E7736" />
        </svg>
      ),
    },
  ];

  const handleScroll = () => {
    if (!scrollContainerRef.current) return;
    const { scrollLeft, clientWidth } = scrollContainerRef.current;
    const cardUnitWidth = clientWidth * 0.86;
    const index = Math.round(scrollLeft / (cardUnitWidth + 16));
    setActiveSlide(Math.min(Math.max(index, 0), cards.length - 1));
  };

  const scrollToSlide = (index: number) => {
    if (!scrollContainerRef.current) return;
    const { clientWidth } = scrollContainerRef.current;
    const cardUnitWidth = clientWidth * 0.86;
    scrollContainerRef.current.scrollTo({
      left: index * (cardUnitWidth + 16),
      behavior: "smooth",
    });
    setActiveSlide(index);
  };

  return (
    <Box
      sx={{
        backgroundColor: "#FAF8F5",
        py: { xs: 4, md: 6 },
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Root Gradient Defs (always visible in DOM so mobile & desktop SVG fills never vanish) */}
      <svg width="0" height="0" style={{ position: "absolute", pointerEvents: "none" }}>
        <defs>
          <linearGradient id="goldLotus" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#DFBA73" />
            <stop offset="50%" stopColor="#C5A059" />
            <stop offset="100%" stopColor="#8C6826" />
          </linearGradient>
          <linearGradient id="goldZen" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#DFBA73" />
            <stop offset="50%" stopColor="#C5A059" />
            <stop offset="100%" stopColor="#8C6826" />
          </linearGradient>
          <linearGradient id="goldLocation" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#DFBA73" />
            <stop offset="50%" stopColor="#C5A059" />
            <stop offset="100%" stopColor="#8C6826" />
          </linearGradient>
        </defs>
      </svg>

      <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 3, md: 3 } }}>
        {/* Desktop Grid Layout (md and up) */}
        <Grid container spacing={3} sx={{ display: { xs: "none", md: "flex" } }}>
          {cards.map((card) => (
            <Grid item xs={12} md={4} key={card.id}>
              <Box
                sx={{
                  backgroundColor: "#FFFFFF",
                  border: "1px solid rgba(158, 119, 54, 0.18)",
                  borderRadius: "20px",
                  p: 4,
                  height: "100%",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  boxShadow: "0 10px 30px -10px rgba(45, 33, 26, 0.05)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 18px 40px -10px rgba(158, 119, 54, 0.18)",
                    transform: "translateY(-4px)",
                    borderColor: "rgba(158, 119, 54, 0.38)",
                    "& .icon-circle": {
                      transform: "scale(1.06)",
                      boxShadow: "0 8px 20px rgba(158, 119, 54, 0.25)",
                    },
                  },
                }}
              >
                <Box
                  className="icon-circle"
                  sx={{
                    width: 72,
                    height: 72,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, rgba(223, 186, 115, 0.22) 0%, rgba(158, 119, 54, 0.12) 100%)",
                    border: "1.5px solid rgba(158, 119, 54, 0.32)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2.5,
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 12px rgba(158, 119, 54, 0.1)",
                  }}
                >
                  {card.icon}
                </Box>
                <Typography
                  variant="h4"
                  sx={{
                    mb: 1.5,
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    color: "#1C1612",
                    fontWeight: 700,
                    fontSize: "1.22rem",
                    letterSpacing: "-0.01em",
                  }}
                >
                  {card.title}
                </Typography>
                <Typography variant="body1" sx={{ color: "#68594F", fontSize: "0.92rem", lineHeight: 1.7 }}>
                  {card.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Mobile / Tablet Touch Carousel (xs to md) */}
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          <Box
            ref={scrollContainerRef}
            onScroll={handleScroll}
            sx={{
              display: "flex",
              gap: 2,
              overflowX: "auto",
              scrollSnapType: "x mandatory",
              WebkitOverflowScrolling: "touch",
              px: { xs: 2.5, sm: 3 },
              py: 1,
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
            }}
          >
            {cards.map((card) => (
              <Box
                key={card.id}
                sx={{
                  flex: "0 0 86%",
                  maxWidth: "86%",
                  scrollSnapAlign: "center",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid rgba(158, 119, 54, 0.18)",
                  borderRadius: "20px",
                  p: { xs: 3, sm: 3.5 },
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  boxShadow: "0 10px 28px -8px rgba(45, 33, 26, 0.08)",
                }}
              >
                <Box
                  sx={{
                    width: 68,
                    height: 68,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, rgba(223, 186, 115, 0.22) 0%, rgba(158, 119, 54, 0.12) 100%)",
                    border: "1.5px solid rgba(158, 119, 54, 0.32)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                    boxShadow: "0 4px 12px rgba(158, 119, 54, 0.1)",
                  }}
                >
                  {card.icon}
                </Box>
                <Typography
                  variant="h4"
                  sx={{
                    mb: 1.2,
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    color: "#1C1612",
                    fontWeight: 700,
                    fontSize: "1.15rem",
                    letterSpacing: "-0.01em",
                  }}
                >
                  {card.title}
                </Typography>
                <Typography variant="body1" sx={{ color: "#68594F", fontSize: "0.88rem", lineHeight: 1.65 }}>
                  {card.desc}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Carousel Pagination Indicator Dots */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1.2,
              mt: 2.5,
            }}
          >
            {cards.map((card, idx) => (
              <Box
                key={card.id}
                onClick={() => scrollToSlide(idx)}
                sx={{
                  height: 6,
                  width: activeSlide === idx ? 28 : 8,
                  borderRadius: "4px",
                  background:
                    activeSlide === idx
                      ? "linear-gradient(135deg, #DFBA73 0%, #C5A059 50%, #9E7736 100%)"
                      : "rgba(158, 119, 54, 0.25)",
                  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                  cursor: "pointer",
                }}
              />
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};